import { ContactInfoPutRequestBody, ContactInfoRequestParams, ContactInfoPutResponse } from '@lio/api-types';
import { customerQueryKey } from '@services/customer/keys';
import { useQueryClient, useMutation } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';

export const useUpdateCustomerAddressesContactInfo = () => {
  const client = useClient();
  const queryClient = useQueryClient();
  const mutationFn = ({ customerId, addresses }: ContactInfoPutRequestBody & ContactInfoRequestParams) =>
    client
      .put(`customer/${customerId}/contact-info`, {
        json: {
          addresses,
        },
      })
      .json<ContactInfoPutResponse>();

  const result = useMutation({
    mutationFn,
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({
        queryKey: customerQueryKey._customerContactInfo(variables.customerId),
      });
    },
  });

  return { ...result, updateCustomerContactInfo: result.mutateAsync };
};
